export const GET_VERSION_REQUEST = 'GET_VERSION_REQUEST';
export const GET_VERSION_SUCCESS = 'GET_VERSION_SUCCESS';
export const GET_VERSION_FAILURE = 'GET_VERSION_FAILURE';

export const UPDATE_VERSION_REQUEST = 'UPDATE_VERSION_REQUEST';
export const UPDATE_VERSION_SUCCESS = 'UPDATE_VERSION_SUCCESS';
export const UPDATE_VERSION_FAILURE = 'UPDATE_VERSION_FAILURE';